import actionCreatorFactory from 'typescript-fsa';
import { ApiFieldError } from 'src/types';

export const actionCreator = actionCreatorFactory(
  `@@LENDSMARTMANAGER/features/lending_terms`
);
export type APIError = ApiFieldError;
export type UpdateTaskParams = any;

export const describeLendingTermsActions = actionCreator.async<
  any,
  any,
  APIError[]
>('request-lendingterms');

export const updateLendingTermsActions = actionCreator.async<
  UpdateTaskParams,
  any,
  APIError[]
>(`update`);
